import { AlloyButton } from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { updatePackageCartQuantities } from '../../../../../../../store/orders/actions';
import styles from './UpdateCartQuantitiesButton.module.scss';

const UpdateCartQuantitiesButton = ({ isUpdateCartQuantitiesDisabled }) => {
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const UpdateCartQuantities = () => {
    dispatch(updatePackageCartQuantities(t));
  };

  return (
    <AlloyButton
      buttonType="secondary"
      onClick={UpdateCartQuantities}
      disabled={isUpdateCartQuantitiesDisabled}
      size="dynamic"
      className={`col-12 ${styles['update-cart-quantities__button']}`}
    >
      {t('PACKAGE_UPDATE_CTA')}
    </AlloyButton>
  );
};

UpdateCartQuantitiesButton.propTypes = {
  isUpdateCartQuantitiesDisabled: PropTypes.bool
};
export default UpdateCartQuantitiesButton;
